import MessageType from '../../../enums/MessageType';
import Language from '../../../v2/lang/language';

export default (type) => {
  if (Language.doesTranslationExist(`checkout.payment.method.adyenv2.${type}.message`)) {
    return ({
      type: MessageType.INFO,
      translationKey: `checkout.payment.method.adyenv2.${type}.message`,
    });
  }
  
  return null;
};
